import { httpBaseUploadUtils, httpBaseUtils } from './httpBaseUtil';

export function fetch(endpoint, params, headers) {
  return httpBaseUtils().get(`/${endpoint}`, { params, headers });
}

export function store(endpoint, data) {
  return httpBaseUtils().post(`/${endpoint}`, data);
}

export function update(endpoint, data) {
  return httpBaseUtils().put(`/${endpoint}`, data);
}

export function destroy(endpoint, data) {
  return httpBaseUtils().delete(`/${endpoint}`, {data});
}

export function download(endpoint, params) {
  return httpBaseUtils(true).get(`/${endpoint}`, { params });
}

export function downloadFile(endpoint, data) {
  return httpBaseUtils(true).post(`/${endpoint}`, data);
}

export function uploadFile(endpoint, data) {
  return httpBaseUploadUtils().post(`/${endpoint}`, data);
}